<template>
  <Teleport to="body">
    <div class="toast-container">
      <TransitionGroup name="toast-anim">
        <div
          v-for="t in toast.toasts"
          :key="t.id"
          class="toast"
          :class="t.type"
        >
          {{ t.message }}
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup>
import { useToastStore } from '@/stores/toast'
const toast = useToastStore()
</script>

<style scoped>
.toast-anim-enter-active,
.toast-anim-leave-active { transition: all .2s ease; }
.toast-anim-enter-from { opacity: 0; transform: translateY(8px); }
.toast-anim-leave-to   { opacity: 0; transform: translateX(20px); }
</style>
